import { isNil } from "@etudescarre/utils";
import { toaster } from "@/app";
import { apiClient } from "@/lib/api/client";

const DOWNLOADS_NOT_DELIVERED_MESSAGE =
  "Les téléchargements de votre type de contrat ne sont pas encore disponibles.";

/**
 * Why these contracts have no download, null when they do. Of the N5 exports
 * only the general nomenclature exists, a rang 1 export.
 */
export function downloadsRefusal(contractTypes: string[]): string | null {
  return contractTypes.includes("travaux_n_1")
    ? null
    : DOWNLOADS_NOT_DELIVERED_MESSAGE;
}

function notifyFailure() {
  toaster.error({
    title: "Téléchargement impossible",
    description:
      "La nomenclature du chantier n'a pas pu être générée. Réessayez dans un instant.",
  });
}

/** Generates and downloads the yard's "nomenclature générale" CSV. */
export async function downloadNomenclature(yardId: string) {
  try {
    const { data, error } = await apiClient.GET(
      "/api/yards/{yardId}/downloads/{type}",
      {
        params: { path: { yardId, type: "nomenclature-generale" } },
        parseAs: "blob",
      },
    );
    if (error || isNil(data)) {
      notifyFailure();
      return;
    }
    const url = URL.createObjectURL(data);
    const link = document.createElement("a");
    link.href = url;
    link.download = `nomenclature-${yardId}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
  } catch {
    notifyFailure();
  }
}
